import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import { hasPermission } from "../../utils/permission";

function Dashboard() {
  const navigate = useNavigate();

  const [stats, setStats] = useState({});

  const admin = JSON.parse(
    localStorage.getItem("admin") || "{}"
  );

  const isSuperAdmin = admin.role_name === "Super Admin";

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {

      const token =
        localStorage.getItem("adminToken");

      const url = isSuperAdmin
        ? "/admin/super-dashboard"
        : "/admin/dashboard";

      const res = await API.get(
        url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setStats(res.data);

    } catch (err) {
      console.log(err);
    }
  };

  const superCards = [
    {
      title: "Businesses",
      value: stats.businesses,
      path: "/admin/businesses",
      permission: "business.view",
    },
    {
      title: "Active Businesses",
      value: stats.activeBusinesses,
      path: "/admin/businesses",
      permission: "business.view",
    },
    {
      title: "Inactive Businesses",
      value: stats.inactiveBusinesses,
      path: "/admin/businesses",
      permission: "business.view",
    },
    {
      title: "Total Users",
      value: stats.users,
      path: "/admin/users",
      permission: "user.view",
    },
  ];

  const businessCards = [
    {
      title: "Categories",
      value: stats.categories,
      path: "/admin/categories",
      permission: "category.view",
    },
    {
      title: "Products",
      value: stats.products,
      path: "/admin/products",
      permission: "product.view",
    },
    {
      title: "Customers",
      value: stats.customers,
      path: "/admin/customers",
      permission: "customer.view",
    },
    {
      title: "Suppliers",
      value: stats.suppliers,
      path: "/admin/suppliers",
      permission: "supplier.view",
    },
    {
      title: "Total Stock",
      value: stats.totalStock,
      path: "/admin/products",
      permission: "product.view",
    },
    {
      title: "Low Stock",
      value: stats.lowStock,
      path: "/admin/low-stock",
      permission: "low_stock.view",
    },
    {
      title: "Purchases",
      value: stats.purchases,
      path: "/admin/purchases",
      permission: "purchase.view",
    },
    {
      title: "Invoices",
      value: stats.invoices,
      path: "/admin/invoices",
      permission: "invoice.view",
    },

    {
      title: "Invoice Due",

      value:
        `₹${Number(
          stats.invoiceDue || 0
        ).toFixed(2)}`,

      path:
        "/admin/invoices",

      permission:
        "invoice.view"
    },

    {
      title: "Purchase Due",

      value:
        `₹${Number(
          stats.purchaseDue || 0
        ).toFixed(2)}`,

      path:
        "/admin/purchases",

      permission:
        "purchase.view"
    },
  ];

  const cards =
    isSuperAdmin
      ? superCards
      : businessCards;

  return (
    <div>

      <h1
        className="
        text-4xl
        font-bold
        mb-8
      "
      >
        Dashboard
      </h1>

      <div
        className="
        grid
        grid-cols-1
        md:grid-cols-2
        xl:grid-cols-4
        gap-6
      "
      >
        {cards
          .filter(card => hasPermission(card.permission))
          .map(
            (card, index) => (
              <div
                key={index}
                onClick={() =>
                  navigate(card.path)
                }
                className="
              bg-[#111]
              border
              border-yellow-500/20
              rounded-2xl
              p-6
              cursor-pointer
              hover:border-yellow-500
              hover:-translate-y-1
              transition-all
            "
              >
                <p className="text-gray-400">
                  {card.title}
                </p>

                <h2
                  className="
                text-4xl
                font-bold
                mt-3
              "
                >
                  {card.value || 0}
                </h2>

                <p
                  className="
                text-yellow-400
                mt-4
              "
                >
                  Click to view →
                </p>
              </div>
            )
          )}
      </div>

      {
        !isSuperAdmin && (
      <div
        className="
mt-10
grid
lg:grid-cols-2
gap-6
"
      >

        <div
          className="
bg-[#111]
rounded-2xl
border
border-yellow-500/20
overflow-hidden
"
        >

          <div className="p-6 border-b border-yellow-500/20">

            <h2 className="text-xl font-bold">

              Invoice Due Collection

            </h2>

          </div>

          <div className="overflow-x-auto">

            <table className="w-full">

              <thead>

                <tr>

                  <th className="p-3 text-left">

                    Invoice

                  </th>

                  <th className="p-3">

                    Customer

                  </th>

                  <th className="p-3">

                    Due

                  </th>

                  <th className="p-3">

                    Action

                  </th>

                </tr>

              </thead>

              <tbody>

                {

                  (stats.invoiceDueList || []).map(item => (

                    <tr
                      key={item.id}
                      className="border-t border-yellow-500/10"
                    >

                      <td className="p-3">

                        {item.invoice_no}

                      </td>

                      <td className="p-3">

                        {item.customer_name}

                      </td>

                      <td className="p-3 text-green-400">

                        ₹{Number(item.remaining_amount).toFixed(2)}

                      </td>

                      <td className="p-3">

                        <button

                          onClick={() => navigate(

                            `/admin/invoices/payment/${item.id}`

                          )}

                          className="
bg-green-600
px-3
py-2
rounded-lg
"

                        >

                          Collect

                        </button>

                      </td>

                    </tr>

                  ))

                }

              </tbody>

            </table>

          </div>

        </div>

        <div
          className="
bg-[#111]
rounded-2xl
border
border-yellow-500/20
overflow-hidden
"
        >

          <div className="p-6 border-b border-yellow-500/20">

            <h2 className="text-xl font-bold">

              Purchase Due Payment

            </h2>

          </div>

          <div className="overflow-x-auto">

            <table className="w-full">

              <thead>

                <tr>

                  <th className="p-3 text-left">

                    Invoice

                  </th>

                  <th className="p-3 text-left">

                    Supplier

                  </th>

                  <th className="p-3 text-left">

                    Due

                  </th>

                  <th className="p-3 text-left">

                    Action

                  </th>

                </tr>

              </thead>

              <tbody>

                {

                  (stats.purchaseDueList || []).map(item => (

                    <tr
                      key={item.id}
                      className="border-t border-yellow-500/10"
                    >

                      <td className="p-3">

                        {item.invoice_no}

                      </td>

                      <td className="p-3">

                        {item.supplier_name}

                      </td>

                      <td className="p-3 text-red-400">

                        ₹{Number(item.due_amount).toFixed(2)}

                      </td>

                      <td className="p-3">

                        <button

                          onClick={() =>

                            navigate(
                              "/admin/purchases/receive-payment",
                              {
                                state: {
                                  purchase: item
                                }
                              }
                            )
                          }

                          className="
bg-red-600
px-3
py-2
rounded-lg
"

                        >

                          Pay

                        </button>

                      </td>

                    </tr>

                  ))

                }

              </tbody>

            </table>

          </div>

        </div>

      </div>
        )
      }

      {/* Quick Summary */}

      {hasPermission("product.view") && (
        <>
          <div
            className="
        mt-10
        bg-[#111]
        rounded-2xl
        border
        border-yellow-500/20
        p-8
      "
          >
            <h2
              className="
          text-2xl
          font-bold
          mb-6
        "
            >
              Business Summary
            </h2>

            <div
              className="
          grid
          md:grid-cols-2
          gap-6
        "
            >
              <div
                className="
            bg-black/40
            p-5
            rounded-xl
          "
              >
                <p className="text-gray-400">
                  Total Stock Available
                </p>

                <h3
                  className="
              text-3xl
              font-bold
              text-green-400
              mt-2
            "
                >
                  {stats.totalStock || 0}
                </h3>
              </div>

              <div
                className="
            bg-black/40
            p-5
            rounded-xl
          "
              >
                <p className="text-gray-400">
                  Low Stock Products
                </p>

                <h3
                  className="
              text-3xl
              font-bold
              text-red-400
              mt-2
            "
                >
                  {stats.lowStock || 0}
                </h3>
              </div>
            </div>

          </div>
        </>
      )}

      

      {
        isSuperAdmin && (

          <div
            className="
mt-10
grid
md:grid-cols-4
gap-6
">

            <div className="bg-[#111] p-6 rounded-2xl">
              <p>Total Revenue</p>
              <h2 className="text-3xl font-bold text-green-400">
                ₹{stats.totalRevenue}
              </h2>
            </div>

            <div className="bg-[#111] p-6 rounded-2xl">
              <p>Total Businesses</p>
              <h2 className="text-3xl font-bold">
                {stats.businesses}
              </h2>
            </div>

            <div className="bg-[#111] p-6 rounded-2xl">
              <p>Active Businesses</p>
              <h2 className="text-3xl font-bold text-green-400">
                {stats.activeBusinesses}
              </h2>
            </div>

            <div className="bg-[#111] p-6 rounded-2xl">
              <p>Total Users</p>
              <h2 className="text-3xl font-bold">
                {stats.users}
              </h2>
            </div>

          </div>

        )
      }

    </div>
  );
}

export default Dashboard;